import { atom } from 'jotai';
import cuid from 'cuid';

const listLoadQuestionAtom = atom<string>(cuid());
const createQuestionAtom = atom<boolean>(false);
const editQuestionAtom = atom<{
  show: boolean;
  comment_id: string;
  target_title: string;
}>({
  show: false,
  comment_id: '',
  target_title: '',
});

export { listLoadQuestionAtom, createQuestionAtom, editQuestionAtom };
